module.exports = __webpack_public_path__ + "static/media/elderly-man-beard.d202ceb3.svg";